import deepmerge from 'deepmerge';

import OP from '../../bluestone/OP';
import type { Colors } from '../../types';
import baseColors from './base/OP';
import deprecatedColors from './deprecated';
import derivedColors from './derived/OP';

const colors: Colors = {
  ...OP.colors,
  ...deepmerge(
    deprecatedColors(baseColors, baseColors.primary['50']),
    baseColors
  ),
  ...derivedColors(baseColors),
};

export default colors;
